import { useMemo } from "react";

import PackingListSelect from "@RequestFormV2/sections/PackingList/components/shared/PackingListSelect";
import { getPackingListFieldPath } from "@RequestFormV2/sections/PackingList/utils/fieldPaths";

type DimensionUnitSelectProps = {
  index: number;
  options: { label: string; value: string }[];
  onChange: () => void;
};

export default function DimensionUnitSelect({ index, options, onChange }: DimensionUnitSelectProps) {
  const normalizedOptions = useMemo(
    () => options.map((option) => ({ ...option, label: option.label.toLowerCase() })),
    [options],
  );

  return (
    <div className="rfv2-packing-list-table__dimension-unit">
      <PackingListSelect
        isSearchable={false}
        name={getPackingListFieldPath(index, "m_unit")}
        options={normalizedOptions}
        onChange={onChange}
      />
    </div>
  );
}
